<template>
  <div class="bg-[#f9f8f6]">
    <Container>

      <div class="lg:flex pt-12 pb-16 lg:pt-16 lg:pb-24 lg:gap-12 xl:gap-16">
        <FadeIn class="text-center lg:text-left mx-auto md:max-w-[75%] lg:max-w-[50%] lg:mx-0 lg:flex-shrink-0 sm:mt-0 lg:flex lg:items-center"> 
          <div>
            <div class="mb-2 md:mb-4" v-if="content.pretitle">
              <span class="rounded-full mr-2 sm:mr-0 mb-2 sm:mb-0 bg-[#5a6ded] px-2 py-0 text-xs inline-block font-semibold leading-6 text-white no-underline">
                {{ content.pretitle }}
              </span>
            </div>
            <h1 
            id="main-title" 
            :class="[
              content.title.length > 58 ? 
              'text-2xl leading-[1.25] sm:text-3xl sm:leading-[1.2] md:text-4xl md:leading-[1.17] font-bold tracking-tight text-gray-900 lora' :
              'text-3xl leading-[1.25] sm:text-4xl sm:leading-[1.2] md:text-5xl md:leading-[1.12] font-bold tracking-tight text-gray-900 lora'
            ]">
              {{ content.title }}
            </h1>
            <div 
            v-if="content.subtitle" 
            class="text-subtitle lg:max-w-[85%]" 
            v-interpolation 
            v-html="content.subtitle">
            </div>
            <div 
            v-if="content.cta?.length > 0"
            class="mt-4 lg:mt-8 flex items-center gap-x-6 justify-center lg:justify-start">
              <ElementButton
              v-for="(cta, index) in content.cta"
              :key="'cta-'+index"
              :url="cta.cta_id.url" 
              :type="cta.cta_id.type"
              :size="cta.cta_id.size"
              :arrow="cta.cta_id.arrow"
              :index="index"
              >
                {{ cta.cta_id.title }}
              </ElementButton>
            </div>
          </div>
        </FadeIn>
        <FadeIn 
        delay="200"
        class="mx-auto mt-8 flex md:mt-16 w-full lg:mt-0 md:px-8 lg:px-0"
        >
          <LottiePlayer
          v-if="content?.lottie"
          :src="`https://media.elker.com/${content?.lottie.id}/${content?.lottie.filename_download}`"
          wrapper-class="rounded-[20px] overflow-hidden"
          />
          <ImageResponsive
          v-else-if="content?.image"
          classes="rounded-[20px] overflow-hidden"
          :data="content?.image"
          :xs="7"
          :sm="7"
          :md="7"
          :lg="6"
          :xl="6"
          />
        </FadeIn>
      </div>

    </Container>
  </div>

</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  }
})
</script>